import { ATTR_NAMES_LEAD } from '~/src/models/constants/attr-names-lead.constants';

export const DROPDOWN_PLACEHOLDER = 'Наименование или ИНН';

export const DROPDOWN_LABEL = 'Организация или ИП';

export const CHECKBOX_LABEL = 'Самозанятый';

export const INITIAL_CREATE_LEAD_DATA_ORGANIZATION = {
    [ATTR_NAMES_LEAD.legalName]: false,
    analyticsWasSend: false,
};

export const INITIAL_CREATE_LEAD_DATA_INN = {
    [ATTR_NAMES_LEAD.inn]: false,
    analyticsWasSend: false,
};

export const INITIAL_CREATE_LEAD_DATA_OGRN = {
    [ATTR_NAMES_LEAD.ogrn]: false,
    analyticsWasSend: false,
};
